// extracted by mini-css-extract-plugin
module.exports = {"divider":"DividerText_divider__qXYEB","dividerText":"DividerText_dividerText__TxTgc"};